/** The site search parameters a pasted list may set (SITE-24 input), in the cell order of a line. */
export const siteParameterNames = ['dr', 'organicKeywords', 'age'] as const;

export type SiteParameterName = (typeof siteParameterNames)[number];
